import React from 'react';
import { Box, IconButton } from '@zillow/constellation-10';
import { IconSendOutline } from '@zillow/constellation-icons';
import { compactAddMessageContentStyles, compactAddMessageOuterStyles, compactAddMessageWrapperStyles } from './styles';

export type CompactAddMessageLayoutProps = {
  children: React.ReactNode;
  /** Optional content rendered below the input row, spanning the full width (e.g. attachment previews). */
  bottomContent?: React.ReactNode;
  leftButtons?: React.ReactNode;
  onSend: () => void;
  isSendDisabled?: boolean;
  sendMessageDataEventId?: string;
};

/**
 * Compact single-row message layout: left buttons | content (textarea) | circular send button.
 * Optionally renders bottomContent below the row at full width.
 * Used in modals and narrow viewports. Also consumed by AddMessageLayout for its mobile breakpoint.
 */
const CompactAddMessageLayout = React.forwardRef<HTMLDivElement, CompactAddMessageLayoutProps>(
  ({ children, bottomContent, leftButtons, onSend, isSendDisabled = false, sendMessageDataEventId }, ref) => {
    return (
      <Box ref={ref} data-testid="compact-add-message-layout" css={compactAddMessageOuterStyles}>
        <Box css={compactAddMessageWrapperStyles}>
          {leftButtons}

          <Box css={compactAddMessageContentStyles}>{children}</Box>

          <IconButton
            {...(sendMessageDataEventId ? { 'data-eventid': sendMessageDataEventId } : {})}
            title="Send message"
            tone="brand"
            emphasis="filled"
            shape="circle"
            size="md"
            onClick={() => onSend()}
            disabled={isSendDisabled}
            icon={<IconSendOutline />}
          />
        </Box>

        {bottomContent}
      </Box>
    );
  },
);

CompactAddMessageLayout.displayName = 'CompactAddMessageLayout';

export default CompactAddMessageLayout;
